import React from 'react';
import './MenuItem.scss';

interface MenuItemProps {
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  danger?: boolean;
}

const MenuItem: React.FC<MenuItemProps> = ({
  onClick,
  children,
  className = '',
  danger = false,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`shared-menu-item ${danger ? 'shared-menu-item--danger' : ''} ${className}`}
  >
    {children}
  </button>
);

export default MenuItem;
